import React, { ReactNode } from "react";
import { useLocation } from '@gatsbyjs/reach-router';
import { routes } from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/flow/confirmation-flow";
import { homePath } from "@nvs/gatsby-theme-leap-core/src/components/domains/flow/flow";
import HeroBackground from "./../../../../../../components/hero-background";

const Main: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isBackground = location.pathname === homePath || (location.pathname.includes(routes.confirmed) && !location.pathname.includes(routes.print));
  return (
    <div>
      <main className="text-font">
        {isBackground && <HeroBackground />}
        {children}
      </main>
    </div>
  );
};

export default Main;
